import type { AnalyticsObject, AnalyticsProperties } from '../types'

export class TopProviders implements AnalyticsObject {
  name: string
  properties: TopProvidersProperties
  constructor(properties: TopProvidersProperties) {
    this.name = 'IMT Top Providers'
    this.properties = properties
  }
}

export interface TopProvidersProperties extends AnalyticsProperties {
  topProviders: {
    nbOfSearches: number
    overallCheapest?: string
    overallBestRated?: string
    overallFastest?: string
    bankCheapest?: string
    bankBestRated?: string
    bankFastest?: string
    cashCheapest?: string
    cashBestRated?: string
    cashFastest?: string
  }
}
